
export const PRODUCT_TYPE = {
    configurable: 'configurable',
    grouped: 'grouped',
    simple: 'simple',
    bundle: 'bundle',
    downloadable: 'downloadable',
    virtual: 'virtual'
};

export const REVIEW_POPUP_ID = 'REVIEW_POPUP_ID';

export default PRODUCT_TYPE;